// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__F534H","container":"Footer_container__dbkvH","column":"Footer_column__O3KV1","logo":"Footer_logo__1hNxC","bottom":"Footer_bottom__boMMN"};